import { Box, Image } from '@mantine/core'
import React from 'react'
import MerchantLoginForm from './components/MerchantLoginForm'

export default function MerchantLogin() {
  return (
    <div className={'max-w-xl m-auto'}>
      <Box className="bg-[#3A55DD] pb-4 h-screen">
        <Image src="./banner.png" />
        <div className="mx-4 bg-white rounded-3xl px-10 py-5 mb-4">
          <MerchantLoginForm />
        </div>
      </Box>
    </div>
  )
}
